export default {
  title: 'Zona Horaria',
  currentTime: 'Hora actual',
  pinned: 'Frecuentemente usado',
  prev: 'Zona horaria anterior',
  next: 'Próxima zona horaria',
  confirm: 'Aplicar',
  hint: 'Desplácese o use las teclas de flecha para cambiar la zona horaria; la página se recarga después de aplicar',
  cities: {
    m720: 'Línea Internacional de Cambio de Fecha Oeste',
    m660: 'Isla Midway',
    m600: 'Hawái',
    m540: 'Alaska',
    m480: 'Tijuana, Baja California, Zona Horaria del Pacífico (EE. UU. y Canadá)',
    m420: 'Arizona, Chihuahua, La Paz, Mazatlán, Zona Horaria de Montaña (EE. UU. y Canadá)',
    m360: 'Guadalajara, Ciudad de México, Monterrey, Saskatchewan, América Central, Zona Horaria Central (EE. UU. y Canadá)',
    m300: 'Indiana (Este), Bogotá, Lima, Quito, Zona Horaria del Este (EE. UU. y Canadá), Caracas',
    m240: 'Asunción, Santiago, Georgetown, La Paz, San Juan, Manaos, Zona Horaria del Atlántico (Canadá), Terranova',
    m180: 'Cayena, Groenlandia, Buenos Aires, Brasilia, Montevideo',
    m120: 'Atlántico Medio',
    m60: 'Azores, Islas de Cabo Verde',
    p0: 'Casablanca, Dublín, Edimburgo, Lisboa, Londres, Monrovia, Reikiavik, UTC',
    p60: 'Ámsterdam, Berlín, Berna, Roma, Estocolmo, Viena, Sarajevo, Escopje, Varsovia, Zagreb, Bruselas, Copenhague, Madrid, París, Belgrado, Bratislava, Budapest, Liubliana, Praga, África Occidental Central',
    p120: 'Atenas, Bucarest, Estambul, Amán, Windhoek, Jerusalén, El Cairo, Harare, Pretoria, Beirut, Helsinki, Kiev, Riga, Sofía, Tallin, Vilna, Minsk',
    p180: 'Kuwait, Riad, Tiflis, Nairobi, Bagdad, Moscú, San Petersburgo, Volgogrado, Teherán',
    p240: 'Abu Dabi, Muscat, Ereván, Bakú, Puerto Luis, Kabul',
    p300: 'Islamabad, Karachi, Ekaterimburgo, Tashkent, Sri Jayawardenepura, Chennai, Kolkata, Bombay, Nueva Delhi, Katmandú',
    p360: 'Astaná, Daca, Almaty, Novosibirsk, Yangon',
    p420: 'Krasnoyarsk, Bangkok, Hanoi, Jakarta',
    p480: 'Irkutsk, Ulán Bator, Kuala Lumpur, Singapur, Perth, Taipei, Pekín, Chongqing, Hong Kong RAS, Urumqi',
    p540: 'Seúl, Yakutsk, Osaka, Sapporo, Tokio, Adelaida, Darwin',
    p600: 'Vladivostok, Canberra, Melbourne, Sídney, Guam, Puerto Moresby, Brisbane, Hobart',
    p660: 'Magadán, Islas Salomón, Nueva Caledonia',
    p720: 'Auckland, Wellington, Fiji, Islas Marshall, Petropávlovsk-Kamchatski',
    p780: 'Samoa, Nukualofa',
    p840: 'Kiritimati, Islas Line'
  }
};
